import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductInterface } from '@vendasta/marketplace-packages';

export interface ProductSelectorConfig {
  products$: Observable<ProductInterface[]>;
}
export const PRODUCT_SELECTOR_CONFIG_TOKEN = new InjectionToken<ProductSelectorConfig>(
  'general dependency data for the product selector filter',
);

export const PRODUCTS_TOKEN: InjectionToken<Observable<ProductInterface[]>> = new InjectionToken(
  'token for all products',
);
